import { Box, Typography } from "@mui/material";
import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import sceneDescriptionImage from "../../../../../../../assets/images/pngs/Automotive/BestPractices/image-with-generated-background.png"
import styles from "./SceneDescriptionContent.module.scss";

export const SceneDescriptionContent = () => {
	const { t } = useTranslation("translation", {
		keyPrefix: "playground.automotive.bestPractices.content.sceneDescriptionSection",
	});

	const listItems = [
		{
			id: "vehicle",
			title: t("listContent.vehicle.title"),
			desc: t("listContent.vehicle.desc"),
			describeSentence: t("listContent.vehicle.describeSentence"),
		},
		{
			id: "road",
			title: t("listContent.road.title"),
			desc: t("listContent.road.desc"),
			describeSentence: t("listContent.road.describeSentence"),
		},
		{
			id: "background",
			title: t("listContent.background.title"),
			desc: t("listContent.background.desc"),
			describeSentence: t("listContent.background.describeSentence"),
		},
		{
			id: "lighting",
			title: t("listContent.lighting.title"),
			desc: t("listContent.lighting.desc"),
			describeSentence: t("listContent.lighting.describeSentence"),
		},
		{
			id: "additionalDescriptors",
			title: t("listContent.additionalDescriptors.title"),
			desc: t("listContent.additionalDescriptors.desc"),
			describeSentence: t("listContent.additionalDescriptors.describeSentence"),
		},
	];

	return (
		<Box className={styles.container}>
			<Box className={styles.listContainer}>
				{listItems.map((item) => (
					<Box key={item.id}>
						<Box className={styles.titleContainer}>
							<Box className={clsx(styles.circle, styles[item.id])}></Box>
							<Typography className={styles.title}>{item.title}</Typography>
						</Box>
						<Typography className={styles.description}>{item.desc}</Typography>
					</Box>
				))}
			</Box>
			<Box className={styles.promptExample}>
				<Box>
					<Typography className={styles.title}>{t("exampleTitle")}</Typography>
					<Typography className={styles.exampleSentence}>
						{listItems.map((item) => (
							<Typography className={clsx(styles.sentence, styles[item.id])}>
								{item.describeSentence}
							</Typography>
						))}
					</Typography>
				</Box>
				<img src={sceneDescriptionImage} alt={t("title")} />
			</Box>
		</Box>
	);
};

export default observer(SceneDescriptionContent);
